import { configs } from './shared-environment/config';
import { apps } from './shared-environment/apps';
import { keys } from './shared-environment/keys';
import { routes } from './shared-environment/routes';
import { versionDev } from './shared-environment/versions';
import { permissionDev } from './shared-environment/permission';

export const environment = {
  production: false,
  qas: false,
  staging: false,
  useFakeBackend: false,
  apiUrl: 'https://api-dev.unico.ligafacens.com/v1.0.0',
  learningApiUrl: 'https://api-learning-dev.unico.ligafacens.com/v1.0.0',
  version: versionDev,
  rc: '0',
  routes,
  keys,
  configs,
  apps,
  permission: permissionDev(),
};
